var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clientId)?_c('div',{ref:"googleButton",staticClass:"tw-w-[250px] tw-mx-auto tw-mb-[50px]",attrs:{"id":"google-signin-button"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }